import React, { createContext } from 'react';
import { useExternalIdentifiers } from './hooks';

export const ExternalIdentifierContext = createContext({});

const ExternalIdentifierStore = ({ clientId, children }) => {
    const value = useExternalIdentifiers({ clientId });

    return <ExternalIdentifierContext.Provider value={value}>{children}</ExternalIdentifierContext.Provider>;
};

export default ExternalIdentifierStore;
